import { Reducer } from 'react';

import { Actions } from './constants';
import { ActionsType, State } from './types';

const initialState: State = {
  list: {},
  isLoading: false,
  error: undefined,
};

const liquidationsReducer: Reducer<State, ActionsType> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_LIQUIDATIONS_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.GET_LIQUIDATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
      };
    case Actions.GET_LIQUIDATIONS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message,
        list: {},
      };
    case Actions.CONFIRM_LIQUIDATION_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.CONFIRM_LIQUIDATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case Actions.CONFIRM_LIQUIDATION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message,
      };
    case Actions.CREATE_LIQUIDATION_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.CREATE_LIQUIDATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case Actions.CREATE_LIQUIDATION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message,
      };

    default:
      return state;
  }
};

export default liquidationsReducer;
